// bm-design-system: stat / KPI tile
//
// A single headline number with a label and optional sub-line, in the app's
// card idiom. Used in the admin dashboard's KPI row.
import * as React from "react";
import { cn } from "@/lib/utils";

export interface StatProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  value: React.ReactNode;
  sub?: React.ReactNode;
}

const Stat = React.forwardRef<HTMLDivElement, StatProps>(
  ({ label, value, sub, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("rounded-lg border border-hairline bg-page p-4", className)}
      {...props}
    >
      <div className="text-xs font-medium uppercase tracking-wide text-ink-muted">
        {label}
      </div>
      <div className="mt-1 font-display text-2xl font-semibold tabular-nums text-ink-display">
        {value}
      </div>
      {sub && <div className="mt-0.5 text-xs text-ink-muted">{sub}</div>}
    </div>
  ),
);
Stat.displayName = "Stat";

export { Stat };
